import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.css';

import AppContainer from './AppContainer';

import store from '../redux/store';

ReactDOM.render(
	<Provider store={store}>
		<AppContainer />
	</Provider>,
	document.getElementById('react')
);


// WEBPACK FOOTER //
// ./src/react/index.jsx